'use client';
import { useState } from 'react';

export function EbookAuthorBio({ bio }: { bio: string }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="text-sm text-white leading-snug">
      <p className={expanded ? undefined : 'line-clamp-2'}>{bio}</p>
      <button
        type="button"
        // This bio lives inside an author <Link>, so a bare click would both
        // toggle AND navigate. Stop propagation (and prevent the default so
        // the parent anchor doesn't treat it as a click either) so tapping
        // Show more/less only expands the text.
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setExpanded((v) => !v);
        }}
        className="mt-1 text-xs text-white/60 hover:text-white underline"
      >
        {expanded ? 'Show less' : 'Show more'}
      </button>
    </div>
  );
}
